/* eslint-disable eslint-comments/disable-enable-pair -- needed */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Card, CardLayout, Heading } from '@americanexpress/dls-react';
import { IconSearch } from '@americanexpress/dls-icons';
import { determineColStyle } from '../utils';
import styles from '../styles/viewall.css';
import CardBenefitsTile from './card-benefits-tile/CardBenefitsTile';
import AnalyticsClick from '../../shared/components/analyticsClick';

export default function Grid(props) {
  const benefitNames = props?.benefitNames;
  const benefits = props?.benefits;
  const cardname = props?.cardname;
  const login = props?.login;
  const columns = props?.columns;
  const mobileView = props?.mobileView;
  const isHorizontalTile = props?.isHorizontalTile;
  const isListView = props?.isListView;
  const analyticsTag = props?.analyticsTag;
  const productSelected = props?.productSelected;
  const searchValue = props?.searchFilter;
  const catalogFilters = props?.catalogFilters;
  const searching = props?.searching;
  const analytics = props?.analytics;
  const track = analytics?.track;
  const localeDetails = props?.localeDetails;

  const generatedMessage = () => {
    return (
      <Card className="margin-2-b fluid">
        <CardLayout className="flex flex-column flex-justify-center text-align-center pad-4-tb position-relative no-scroll">
          <img
            src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.28.0/package/dist/img/brand/flourish.svg"
            className={`flex flex-justify-end ${styles.modalBackground}`}
            alt=""
          />
          <IconSearch
            className="margin-1-b"
            data-testid="iconSearch"
            size={window.screen.availWidth > 768 ? 'xl' : 'lg'}
            color="neutral"
          />
          <div aria-live="polite" role="alert">
            <Heading level={2} variant="sans-medium-regular" className="margin-1-b" role="presentation">
              <FormattedMessage
                id="view-all.search.no-data-heading"
                defaultMessage="We couldn't find search results for "
              />
              {localeDetails === 'ja-JP' ? null : `${searchValue}.`}
            </Heading>
            <p className="margin-3-b">
              <FormattedMessage
                id="view-all.search.no-data"
                defaultMessage="Please check your spelling or try a different search term. "
              />
            </p>
          </div>
          <AnalyticsClick
            element={`${props.cardname}>>search>>new-search`}
            onClick={props.newSearch}
          >
            <Button
              variant="primary"
              type="submit"
              onClick={() => {
                track({
                  event: {
                    element: `${props?.cardname}>>search>>new-search`,
                    type: 'click',
                  },
                });
              }}
              className="margin-auto-lr"
              id="submit-button"
            >
              <FormattedMessage
                id="view-all.search.new-search"
                defaultMessage="New Search"
              />
            </Button>
          </AnalyticsClick>
        </CardLayout>
      </Card>
    );
  };

  if (benefitNames && benefits) {
    const generateRows = () => {
      const items = [];
      const namesToRender = !isListView
        ? (benefitNames && benefitNames).slice(0, 6)
        : benefitNames && benefitNames;
      namesToRender?.forEach((id, idx) => {
        const colWidths = isListView ? 'fluid'
          : `col-md-6 col-lg-4 pad-0-l ${[determineColStyle(columns, idx)]}`;
        if (benefits[id]) {
          items.push(
            <div
              className={
                mobileView
                  ? null
                  : `${colWidths}`
              }
              key={`tile-${benefits[id]?.benefitName}`}
            >
              <CardBenefitsTile
                benefitName={benefits[id].benefitName}
                view="view-all"
                benefitId={id}
                benefit={benefits[id]}
                cardname={cardname}
                login={login}
                showMobileTileView={mobileView}
                isListView={isListView}
                isHorizontalTile={isHorizontalTile}
                analyticsTag={analyticsTag}
                productSelected={productSelected}
                showTerms={false}
                benefitNamesList={benefitNames}
                benefitsData={benefits}
                catalogFilters={catalogFilters}
                searching={searching}
              />
            </div>
          );
        }
      });
      return items;
    };
    return (
      <div
        className={
          mobileView
            ? null
            : 'flex flex-wrap flex-align-content-start'
        }
      >
        {benefitNames.length === 0 ? generatedMessage() : generateRows()}
      </div>
    );
  }
  return null;
}

Grid.propTypes = {
  benefitNames: PropTypes.arrayOf(PropTypes.string),
  login: PropTypes.bool,
  columns: PropTypes.number.isRequired,
  mobileView: PropTypes.bool,
  benefits: PropTypes.shape({}).isRequired,
  isListView: PropTypes.bool,
  isHorizontalTile: PropTypes.bool,
  analyticsTag: PropTypes.string,
  productSelected: PropTypes.string,
  searchFilter: PropTypes.string,
  newSearch: PropTypes.func,
};

Grid.defaultProps = {
  benefitNames: null,
  login: false,
  mobileView: false,
  isListView: false,
  isHorizontalTile: false,
  analyticsTag: 'null',
  productSelected: 'null',
};
